import { Delete } from "@mui/icons-material";
import {
  Card,
  Stack,
  Box,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  CardActionArea,
} from "@mui/material";
import { Item, ShopActionType } from "../../context/shop/shop.types";
import Image from "next/image";
import { useShopContext } from "../../context/shop/shop.context";
import { useTranslation } from "react-i18next";
import { useRouter } from "next/router";
import NextLink from "../others/NextLink";

const ItemDetails = ({
  item,
  disabled,
}: {
  item: Item;
  disabled?: boolean;
}) => {
  const { product, quantity } = item;
  const { t } = useTranslation();
  const router = useRouter();
  const { shopState, shopDispatch, nItems } = useShopContext();
  const featuredImage = product.images?.[0];
  return (
    <Card
      sx={{
        display: "flex",
        flexDirection: "row",
        mb: 2,
        p: 2,
        alignItems: "center",
      }}
    >
      {featuredImage?.src && (
        <Box
          sx={{
            height: 200,
            position: "relative",
            width: 100,
          }}
        >
          <Image
            src={featuredImage?.src}
            alt={featuredImage?.alt ?? ""}
            fill
            sizes={"(max-width: 100)"}
            style={{
              objectFit: "contain",
              objectPosition: "center",
            }}
          />
        </Box>
      )}

      <Stack
        sx={{
          flex: 1,
          pl: 2,
          flexDirection: "column",
          alignItems: "flex-start",
        }}
      >
        <NextLink
          href={`/shop/${product.id}_${product.slug}`}
          style={{
            display: "flex",
            flexDirection: "column",
            alignSelf: "stretch",
          }}
        >
          <Stack
            flexDirection={{ sm: "row", xs: "column" }}
            alignItems={{ sm: "center", xs: "flex-start" }}
            alignSelf="stretch"
            justifyContent="space-between"
          >
            <Typography variant="h5">{product.name}</Typography>
            <Typography variant="h6">
              {(parseFloat(product.price) * quantity).toFixed(2)}€
            </Typography>
          </Stack>

          <Typography variant="body1">
            {parseFloat(product.price).toFixed(2)}€ / {t("articles.piece")}
          </Typography>
        </NextLink>
        <Stack flex={1} />

        <FormControl sx={{ minWidth: (theme) => theme.spacing(20), mt: 2 }}>
          <InputLabel>{t("articles.quantity")}</InputLabel>
          <Select
            id="quantity-select"
            disabled={disabled}
            value={quantity}
            label={t("articles.quantity")}
            onChange={(event) =>
              shopDispatch({
                type: ShopActionType.SET_ITEM_QUANTITY,
                payload: {
                  item: {
                    product,
                    quantity: event.target.value as number,
                  },
                },
              })
            }
          >
            {[...new Array(10)].map((_, index) => (
              <MenuItem key={index} value={index + 1}>
                {index + 1}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        {!disabled && (
          <Button
            onClick={() =>
              shopDispatch({
                type: ShopActionType.TRASH_ITEM,
                payload: { item },
              })
            }
          >
            <Delete />
            {t("articles.delete")}
          </Button>
        )}
      </Stack>
    </Card>
  );
};

export default ItemDetails;
